<template>
  <baseFrame
    :infosArr='infosArr'
    :id='id'
    :idText='idText'
    :showCancelBtn="doCancel"
    @showModal="showModal"
  >
<div slot="content">
  <lk-card title="应付单信息" class="mb16">
    <lk-form
      label-position='right'
      :labelWidth='120'>
      <lk-row>
        <lk-col span='10'>
          <lk-form-item label='供应商名称:'>
            <span>{{info.financePayable.supplierName}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='校验类型:'>
            <span>{{info.financePayable.financePayableCreateType !==2 ? '首次发票录入' : '已校验批次成本调整'}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10'>
          <lk-form-item label='发票号码:'>
            <span>{{info.financePayable.invoiceCode}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='开票日期:'>
            <span>{{info.financePayable.invoiceDate}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='22'>
          <lk-form-item label='付款明细:'>
            <lk-table :columns='columns1' :data='payableList' border></lk-table>
          </lk-form-item>
        </lk-col>
        <lk-col span='10'>
          <lk-form-item label='发票总金额:'>
            <span>{{info.financePayable.invoiceAmount}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='总金额:' v-if="financePayableCreateType !== 2">
            <span>{{info.financePayable.amount}}</span>
          </lk-form-item>
          <lk-form-item label='待抵消总金额:' v-else>
            <span>{{info.financePayable.totalSetOffAmount}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10'>
          <lk-form-item label='发票不含税金额:'>
            <span>{{info.financePayable.invoiceAmountWithoutTax}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='确认不含税总金额:' v-if="financePayableCreateType !== 2">
            <span>{{info.financePayable.amountWithoutTax}}</span>
          </lk-form-item>
          <lk-form-item label='待抵消不含税总金额:' v-else>
            <span>{{info.financePayable.totalSetOffAmountWithoutTax}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10'>
          <lk-form-item label='发票税额:'>
          <span>{{info.financePayable.invoiceTotalTax}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='确认总税金:' v-if="financePayableCreateType !== 2">
            <span>{{info.financePayable.totalTax}}</span>
          </lk-form-item>
          <lk-form-item label='待抵消总税额:' v-else>
            <span>{{info.financePayable.totalSetOffTax}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10'>
          <lk-form-item label='不含税金额差额:'>
            <span :class="{blue: info.financePayable.amountWithoutTaxBalance !== 0}">{{info.financePayable.amountWithoutTaxBalance}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='税额差额:'>
            <span :class="{blue: info.financePayable.taxBalance !== 0}">{{info.financePayable.taxBalance}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='22'>
          <lk-form-item label='备注:'>
            <span>{{info.financePayable.comment}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
    </lk-form>
  </lk-card>
  <lk-card
    title="票折实际批次"
    style="marginTop: 20px;"
    v-if="showActualBatch"
  >
    <lk-form
      :label-width='140'
      label-position="right"
    >
      <lk-row :gutter='16'>
        <lk-col span='10'>
          <lk-form-item label='总票折金额(不含税):' >
            <span>{{totalDiscountAmount}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col span='8'>
          <lk-form-item label='票折对应商品:' >
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col >
          <lk-form-item label='' :label-width='50'>
            <lk-table
              :data='actualBatchInfo'
              :columns='actualBatchColumns'
              border
            ></lk-table>
          </lk-form-item>
        </lk-col>
      </lk-row>
    </lk-form>
  </lk-card>
  <lk-card title="上下查询单据">
      <charts :type="5" :id='this.$route.params.id+""' @handleClick='getChartInfo'></charts>
      <div class="tabs">
        <lk-tabs type='card' v-model="currentTab">
          <lk-tab-pane label="当前单据" v-if="currentSheet.length" name='0'>
              <chartTable :data='currentSheet' :type='currentType'></chartTable>
            </lk-tab-pane>
            <lk-tab-pane label="上查单据" v-if="lastSheet.length" name='1'>
              <chartTable :data='lastSheet' :type='lastType'></chartTable>
              <chartTable v-if="hasDoubleLast" :data='lastSheet2' :type='lastType2'></chartTable>
            </lk-tab-pane>
            <lk-tab-pane label="下查单据" v-if="nextSheet.length" name='2'>
              <chartTable :data='nextSheet' :type='nextType' class="mb16"></chartTable>
              <chartTable v-if="hasDoubleNext" :data='nextSheet2' :type='nextType2'></chartTable>
            </lk-tab-pane>
        </lk-tabs>
      </div>
  </lk-card>
  <lk-modal title="提示" v-model="showAlert">
      <h2 class="leftBorder"><span class="warnIcon iconfont">&#xe613;</span>是否确认发起取消应付单审核？ </h2>
      <h3 class="leftBorder cancelBold">审核通过后，应付单状态将更新为草稿状态，并撤销应付单引起的所有成本调整。</h3>
      <br>
      <h4 class="leftBorder">取消原因：</h4>
      <div class="leftBorder">
        <lk-input type='textarea' :row='4' :maxlength='100' placeholder="请输入取消原因" v-model="reasonCancel" >
        </lk-input>
      </div>
      <br>
      <div class="uploader leftBorder">
        <p>
          <span>附件：</span>
          <Uploader :able="true" v-model="cancelImgUrl">上传附件</Uploader>
        </p>
      </div>
      <div slot="footer">
        <lk-button @click="statusModal = false; reasonCancel=''; file = ''; showAlert=false">取消</lk-button>
        <lk-button type='primary' @click="handleDisable">提交</lk-button>
      </div>
  </lk-modal>
</div>

  </baseFrame>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import charts from '../../components/charts.vue';
import chartTable from '../../components/chartTable.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import refund from '../../services/refund';
import expandRow from './payableExpandRow';
import Uploader from '../../components/Uploader.vue';

export default {
  name: 'payableInfoCheck',
  components: {
    baseFrame, charts, chartTable, Uploader,
  },
  data() {
    return {
      cancelImgUrl: '',
      loading: false,
      reasonCancel: '',
      file: '',
      showAlert: false,
      alertStr: '审核通过后，应付单状态将更新为草稿状态，并撤销应付单引起的所有成本调整',
      showActualBatch: false,
      doCancel: '', // 取消应收单
      actualBatchInfo: [],
      actualBatchColumns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 130 },
        { title: '通用名', key: 'approvedDrugName', minWidth: 130 },
        { title: '商品名', key: 'goodsName', minWidth: 130 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'drugMinimumPackagingUnit', minWidth: 116 },
        {
          title: '本次票折金额',
          key: 'amountWithoutTaxBalance',
          minWidth: 116,
        },
        { title: '票折对应批次', key: 'goodsBatchSeq', minWidth: 116 },
      ],
      infosArr: [],
      currentTab: 0,
      id: '',
      idText: '应付单号',
      currentSheet: [],
      lastSheet: [],
      lastSheet2: [],
      nextSheet: [],
      nextSheet2: [],
      hasDoubleNext: false,
      hasDoubleLast: false,
      currentType: 0,
      referTypeMap: {
        1: '验收',
        2: '退货',
        3: '召回',
      },
      lastType: 0,
      lastType2: 0,
      nextType: 0,
      nextType2: 0,
      chartParams: {
        sourceType: 5, // 1采购计划 2采购订单 3收货单 4验收单 5应付单 6付款单 7退货单
        sourceId: this.$route.params.id, // 应付单号
      },
      financePayableCreateType: null,
      columns1: [],
      payableColumns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h(expandRow, {
            props: {
              row: params.row,
            },
          }),
        },
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '单号', key: 'referCode', minWidth: 116 },
        {
          title: '单据来源',
          key: 'referType',
          minWidth: 116,
          render: (h, params) => h('span', `${this.referTypeMap[params.row.referType]}`),
        },
        { title: '商品通用名称', key: 'approvedDrugName', minWidth: 130 },
        {
          title: '原进项税率',
          key: 'taxRate',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              noEqual: params.row.taxRate !== this.payableList[0].taxRate,
            },

          }, `${params.row.taxRate}%`),
        },
        {
          title: '确认进项税率',
          key: 'realInputTaxRate',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, `${params.row.realInputTaxRate}%`),
        },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        { title: '确认进价', key: 'realPriceWithTax', minWidth: 116 },
        { title: '原总金额', key: 'originalTotalAmount', minWidth: 116 },
        { title: '票折前总金额', key: 'amountBeforeDiscount', minWidth: 116 },
        { title: '票折不含税金额', key: 'discountWithoutTax', minWidth: 136 },
        { title: '票折税额', key: 'discountTax', minWidth: 116 },
        { title: '确认总金额', key: 'confirmedTotalAmount', minWidth: 116 },
        { title: '待抵消金额', key: 'setOffAmount', minWidth: 116 },
        {
          title: '确认不含税单价',
          key: 'realPriceAfterTax',
          minWidth: 136,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.realPriceAfterTax),
        },
        {
          title: '确认不含税总金额',
          key: 'realTotalPriceAfterTax',
          minWidth: 146,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.realTotalPriceAfterTax),
        },
        {
          title: '确认总税金',
          key: 'realTotalTax',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.realTotalTax),
        },
        {
          title: '不含税总差额',
          key: 'amountWithoutTaxBalance',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.amountWithoutTaxBalance),
        },
      ],
      payableList: [],
      info: {
        financePayable: {
          invoiceCode: '',
          invoiceDate: '',
          supplierId: '',
          comment: '',
        },
        purchaseMedicineInfoVoList: [],
      },
    };
  },
  computed: {
    totalDiscountAmount() { // 总票折金额(不含税)
      const amount = this.actualBatchInfo.reduce((pre, current) => utils.formatNum(pre + Number(current.amountWithoutTaxBalance), 10), 0);
      return amount;
    },
  },
  watch: {
    financePayableCreateType: {
      handler(val) {
        this.payableColumns.forEach((item) => {
          if (item.key == 'realTotalPriceAfterTax') {
            item.title = val == 2 ? '待抵消不含税总金额' : '确认不含税总金额';
          }
          if (item.key == 'realTotalTax') {
            item.title = val == 2 ? '待抵消总税金' : '确认总税金';
          }
        });
        if (val !== 2) {
          this.columns1 = this.payableColumns.filter(col => col.key !== 'originalTotalAmount' && col.key !== 'setOffAmount');
        } else {
          this.columns1 = this.payableColumns;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getChartInfo(val) { // 1采购计划 2采购订单 3收货单 4验收单 5应付单 6付款单 7退货单 8召回单
      switch (val.data.type) {
        case 1:
          this.getPurchasePlan(val.data.value);
          break;
        case 2:
          this.getPurchaseOrder(val.data.value);
          break;
        case 3:
          this.getPurchaseReceipt(val.data.value);
          break;
        case 4:
          this.getInspection(val.data.value);
          break;
        case 5:
          this.getPayable(val.data.value);
          break;
        case 6:
          this.getPayment(val.data.value);
          break;
        case 7:
          this.getRefund(val.data.value);
          break;
        case 8:
          this.getRecall(val.data.value);
          break;
        default:
          break;
      }
    },
    fileReader(e) {
      this.loading = true;
      this.file = e.target.files[0];
      e.target.value = null;
      console.log(this.file);
    },
    formatNode(data) {
      this.currentSheet = [];
      this.lastSheet = [];
      this.lastSheet2 = [];
      this.nextSheet = [];
      this.nextSheet2 = [];
      const {
        nextNode, nextNode2, lastNode, lastNode2, currentNode,
      } = data;
      if (nextNode) {
        this.nextType = nextNode.dataType;
        let tempNext = [];
        for (const key in nextNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(nextNode[key]) === '[object Object]') {
              tempNext.push(nextNode[key]);
            } else {
              tempNext = tempNext.concat(nextNode[key]);
            }
          }
        }
        tempNext.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.nextSheet.push(result);
        });
      }
      if (nextNode2) {
        this.hasDoubleNext = true;
        this.nextType2 = nextNode2.dataType;
        let tempNext = [];
        for (const key in nextNode2) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(nextNode2[key]) === '[object Object]') {
              tempNext.push(nextNode2[key]);
            } else {
              tempNext = tempNext.concat(nextNode2[key]);
            }
          }
        }
        tempNext.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.nextSheet2.push(result);
        });
      } else {
        this.hasDoubleNext = false;
      }
      if (lastNode) {
        this.lastType = lastNode.dataType;
        let tempLast = [];
        for (const key in lastNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(lastNode[key]) === '[object Object]') {
              tempLast.push(lastNode[key]);
            } else {
              tempLast = tempLast.concat(lastNode[key]);
            }
          }
        }

        tempLast.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (Object.prototype.toString.call(item[key]) === '[object Object]') {
              result = utils.deepClone(item[key]);
            } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
              if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                result.subList = [];
                item[key].forEach((el) => {
                  const tempItem = {};
                  utils.exchangeTable(el, tempItem);
                  result.subList.push(tempItem);
                });
              }
            }
          }
          this.lastSheet.push(result);
        });
      }
      if (lastNode2) {
        this.hasDoubleLast = true;
        this.lastType2 = lastNode2.dataType;
        let tempLast = [];
        for (const key in lastNode2) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(lastNode2[key]) === '[object Object]') {
              tempLast.push(lastNode2[key]);
            } else {
              tempLast = tempLast.concat(lastNode2[key]);
            }
          }
        }
        tempLast.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (Object.prototype.toString.call(item[key]) === '[object Object]') {
              result = utils.deepClone(item[key]);
            } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
              if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                result.subList = [];
                item[key].forEach((el) => {
                  const tempItem = {};
                  utils.exchangeTable(el, tempItem);
                  result.subList.push(tempItem);
                });
              }
            }
          }
          this.lastSheet2.push(result);
        });
      } else {
        this.hasDoubleLast = false;
      }
      if (currentNode) {
        this.currentType = currentNode.dataType;
        let tempCurrent = [];
        for (const key in currentNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(currentNode[key]) === '[object Object]') {
              tempCurrent.push(currentNode[key]);
            } else {
              tempCurrent = tempCurrent.concat(currentNode[key]);
            }
          }
        }

        tempCurrent.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]') {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.currentSheet.push(result);
        });
      }
    },
    getPayable(id) {
      const params = utils.deepClone(this.chartParams);
      params.financePayableId = id;
      finance.flowInfoPayable(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRecall(id) {
      const params = utils.deepClone(this.chartParams);
      params.recallPlanId = id;
      finance.getInfoAroundRecallPlan(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPayment(id) {
      const params = utils.deepClone(this.chartParams);
      params.financePaymentId = id;
      finance.flowInfoPayment(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRefund(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseRefundId = id;
      refund.purchaseRefundChartLinkInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInspection(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseInspectionId = id;
      finance.flowInfoInspection(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchaseReceipt(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseReceiptId = id;
      finance.flowInfoPurchaseReceipt(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchaseOrder(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseOrderId = id;
      finance.flowInfoPurchaseOrder(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchasePlan(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchasePlanId = id;
      finance.flowInfoPurchasePlan(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDetails() {
      return new Promise((resolve) => {
        finance.getFinancePayableDetail({ financePayableId: `${this.$route.params.id}` }).then((res) => {
          if (res.data.status === 200) {
            const temp = res.data.data;
            this.financePayableCreateType = temp.financePayable.financePayableCreateType;
            this.doCancel = temp.financePayable.doCancel;
            temp.financePayable.invoiceDate = temp.financePayable.invoiceDate ? utils.exchangeTime(temp.financePayable.invoiceDate) : '';
            temp.financePayableInfoList.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              result.inspectionInfoId = item.inspectionInfoId;
              result.purchaseInspectionInfoInspectionCode = item.inspectionCode;
              result.purchaseMedicineApprovedDrugName = item.approvedDrugName;
              result.purchaseMedicineSpecification = item.specification;
              result.purchaseInspectionInfoTaxRate = `${item.taxRate}%`;
              // result.purchaseInspectionInfoPriceBeforeTax = utils.exchangePercent(item.priceAfterTax);
              result.purchaseInspectionInfoTax = item.tax;
              result.inspectionInfoAmount = item.realTotalPriceBeforeTax;
              result.purchaseInspectionInfoPriceBeforeTax = item.priceBeforeTax;
              result.purchaseInspectionInfoPriceAfterTax = item.priceAfterTax;
              // result.purchaseInspectionInfoTotalTax = utils.exchangePercent(item.totalTax);
              result.purchaseInspectionInfoPassNum = item.num;
              result.purchaseInspectionInfoTotalTax = item.totalTax;
              result.purchaseInspectionInfoTotalPriceBeforeTax = item.realTotalPriceBeforeTax;
              result.purchaseMedicineManufacturer = item.manufacturer;
              this.payableList.push(result);
            });
            if (temp.rebateInfoList && temp.rebateInfoList.length) {
              this.showActualBatch = true;
              temp.rebateInfoList.forEach((item) => {
                const result = item;
                result.amountWithoutTaxBalance = item.submitAmount;
                this.actualBatchInfo.push(result);
              });
            }
            this.info = utils.deepClone(temp);
            this.id = this.info.financePayable.code;
            this.infosArr[0] = {
              name: '门店名称:',
              value: this.info.financePayable.storeName,
            };
            this.infosArr[1] = {
              name: '供应商:',
              value: this.info.financePayable.supplierName,
            };
            this.infosArr[2] = {
              name: '创建人:',
              value: this.info.financePayable.createUserName,
            };
            this.infosArr[3] = {
              name: '创建时间:',
              value: utils.exchangeTimeToSecond(this.info.financePayable.createTime),
            };
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleToList() {
      this.$router.push({
        name: 'payable',
      });
    },
    showModal() {
      this.showAlert = true;
    },
    handleDisable() {
      finance.getfinancePayableId({ financePayableId: `${this.$route.params.id}`, reasonCancel: `${this.reasonCancel}`, cancelImgUrl: `${this.cancelImgUrl}` }).then((res) => {
        if (res.data.success === false) {
          setTimeout(() => {
            this.$Modal.confirm({
              title: '该应付单不支持取消，原因如下',
              content: res.data.error,
            });
          }, 200);
        } else {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        }
      });
    },
  },
  created() {
    this.getDetails().then(() => {
      this.getChartInfo({ data: { type: 5, value: this.$route.params.id } });
    });
  },
};
</script>
<style lang="less" scoped>
.blue {
  color: #1890FF;
};
.warnIcon {
  color: #2d8cf0;
  font-size: 20px;
};
.leftBorder {
  padding-left: 30px !important;
}
.cancelBold {
  font-weight: normal;
}
</style>
